import axios from 'axios'
import { BASE_URL } from '@/config/index.js'

const service = axios.create({
  baseURL: BASE_URL, // 后端地址
  timeout: 10000
})

// 响应拦截
service.interceptors.response.use(
  response => response.data,
  error => {
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js